import React from "react";

export const appendBackgroundImage = (url: string): React.CSSProperties =>
  url ? { backgroundImage: `url(${url})` } : null;
